import { Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

export const Amount = ({ amount, currency }: { amount: number; currency: string }) => {
  const {
    company: { locale },
  } = useCurrentSession()
  return (
    <Text.Normal size="200">
      {formattedAmount({
        amountCents: amount || 0,
        currency,
        locale: locale || '',
      })}
    </Text.Normal>
  )
}
